import dayjs from 'dayjs';

export default function getGreeting(date = dayjs()) {
  const hour = dayjs(date).hour();

  if (hour >= 5 && hour < 12) return 'Good Morning';
  if (hour >= 12 && hour < 17) return 'Good Afternoon';
  if (hour >= 17 && hour < 22) return 'Good Evening';

  return 'Hello';
}
